/** Original square seal: an engraved oak-style tree inside a double frame. */
export default function Logo({ size = 48 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true" className="logo">
      <rect x="1" y="1" width="46" height="46" fill="var(--green-deep)" />
      <rect x="4" y="4" width="40" height="40" fill="none" stroke="var(--brass)" strokeWidth="1.2" />
      <path
        d="M24 39V26m0 0-5-4m5 4 5-5m-5 1v-6m-5 2-4-3m13 2 4-3"
        stroke="var(--paper)"
        strokeWidth="2"
        strokeLinecap="square"
        fill="none"
      />
      <path
        d="M24 9c-4 0-6 2.5-6 5-3 0-5 2-5 4.5S15 23 18 23h12c3 0 5-2 5-4.5S33 14 30 14c0-2.5-2-5-6-5Z"
        fill="var(--sage)"
        opacity="0.9"
      />
      <path d="M15 39h18" stroke="var(--brass)" strokeWidth="1.6" />
    </svg>
  );
}
